export enum BodyType {
  A = 'A',
  B = 'B',
}
